import { Component, Input } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { Mission } from '../../models/Missions';
import { CollectionItem } from '../../models/Strapi';

@Component({
    selector: 'app-mission-card',
    templateUrl: './mission-card.component.html',
    styleUrls: ['./mission-card.component.scss'],
    standalone: false
})
export class MissionCardComponent {
  @Input() missionData: CollectionItem<Mission>;
  @Input() isChecked = false;

  env = environment;

  constructor() {
  }
}
